import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { withRouter } from '../../../util/withRouter';

import Header from '../../../components/Header/Header';
import RadioButton from '../../../components/RadioButton/RadioButton';
import { getSso, setSso, fetchSso, error } from '../SsoActions';
import throttle from '../../../util/throttle';

import './SsoConfig.scss';
import _ from 'lodash';

class SsoConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      mode: 0,
      model: {}
    };

    this.getSsoThrottled = throttle(this.getSso, 1000, this);
    this.fetchSsoThrottled = throttle(this.fetchSso, 1000, this);
  }

  componentDidMount() {   
    if (!!this.props.sso) {
      this.setSsoState();
    }
    this.getSso();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.sso, this.props.sso)) {
      this.setSsoState();
    }
    if (this.state.configUrl && prevState.configUrl !== this.state.configUrl) {
      this.fetchSsoThrottled();
    }
  }

  setSsoState() {
    this.setState({
      model: { ...this.state.model, ...this.props.sso },
    });
  }

  getSso() {
    this.props.getSso();
  }

  fetchSso() {
    this.props.fetchSso(this.state.configUrl);
  }

  handleSwitchMode = e => {
    this.setState({ mode: +e.value });
  }

  handleChange = e => {
    let target = e.target;
    if (target.name === 'config-url' && target.value) {
      this.setState({ configUrl: target.value });
    } else {
      const model = { ...this.state.model, [target.name]: target.value };
      this.setState({ model });
    }
  }

  handleSave = () => {
    if (this.validate()) {
      this.props.setSso(this.state.model);
    }
  }

  handleSaveSecret = () => {
    if (this.validateSecret()) {
      const { model } = this.state;
      this.props.setSso({ clientId: model.clientId, clientSecret: model.clientSecret });
    }
  }

  handleVerify = () => {
    global.window && window.location && window.location.replace('/api/sso/verify');
  }

  handleActivate = () => {
    global.window && window.location && window.location.replace('/api/sso/activate');
  }

  validateSecret() {
    const { model } = this.state;
    if (!model.clientId) {
      this.props.setError('Client ID is required');
      return false;
    }
    if (!model.clientSecret) {
      this.props.setError('Client Secret is required');
      return false;
    }
    return true;
  }

  validate() {
    const { model } = this.state;
    if (!model.issuer) {
      this.props.setError('Issuer is required');
      return false;
    }
    if (!model.authEndpoint) {
      this.props.setError('Authorization endpoint is required');
      return false;
    }
    if (!model.tokenEndpoint) {
      this.props.setError('Token endpoint is required');
      return false;
    }
    if (!model.userEndpoint) {
      this.props.setError('User endpoint is required');
      return false;
    }
    if (!model.jwksEndpoint) {
      this.props.setError('JWKS endpoint is required');
      return false;
    }
    if (!model.redirectUrl) {
      this.props.setError('Redirect URL is required');
      return false;
    }
    if (!model.scopes) {
      this.props.setError('Scopes is required');
      return false;
    }
    if (!model.responseTypes) {
      this.props.setError('Response type is required');
      return false;
    }

    return true;
  }

  render() {
    const { loading, sso, user } = this.props;
    const { model, configUrl, mode } = this.state;

    return [
      <Header key="1" title="" showHome={true} />,
      <div key="2" className='content-wrap'>
        <Helmet>
          <title>{pageTitle('Sso')}</title>
        </Helmet>
        <div className='sso_content'>
          { loading && (<div></div>) }
          { !loading && (
            <div className='white_box_details'>
              <h3><span className={`check_mark ${sso.saved ? 'green' : 'gray'}`}></span>Single Sign-On configuration</h3>
     
              <Form className='form_billing'>
                <Row>
                  <Col sm={12}>
                    <Col sm={6}>
                      <Form.Group controlId="mode-0">
                        <RadioButton
                          id="mode-0"
                          name="mode-0"
                          label="Provide all details"
                          value="0"
                          checked={mode === 0}
                          onChange={this.handleSwitchMode}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="mode-1">
                        <RadioButton
                          id="mode-1"
                          name="mode-1"
                          label="Provide configuration URL"
                          value="1"
                          checked={mode === 1}
                          onChange={this.handleSwitchMode}
                        />
                      </Form.Group>
                    </Col>
                  </Col>
                  <Col sm={12}>
                    <hr/>
                  </Col>
                  <Col sm={12}>
                    { mode === 1 && (
                      <Col sm={12}>
                        <Form.Group controlId="config-url">
                          <Form.Label>OpenID configuration URL</Form.Label>
                          <Form.Control type="text" name="config-url" value={configUrl} onChange={this.handleChange} />
                        </Form.Group>
                      </Col>
                    )}
                    <Col sm={6}>
                      <Form.Group controlId="issuer">
                        <Form.Label>Issuer</Form.Label>
                        <Form.Control readOnly={mode} style={{backgroundColor: mode ? '#f3f3f3' : ''}} type="text" name="issuer" value={model.issuer} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="authEndpoint">
                        <Form.Label>Authentication endpoint</Form.Label>
                        <Form.Control readOnly={mode} style={{backgroundColor: mode ? '#f3f3f3' : ''}} type="text" name="authEndpoint" value={model.authEndpoint} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="tokenEndpoint">
                        <Form.Label>Token endpoint</Form.Label>
                        <Form.Control readOnly={mode} style={{backgroundColor: mode ? '#f3f3f3' : ''}} type="url" name="tokenEndpoint" value={model.tokenEndpoint} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="userEndpoint">
                        <Form.Label>User endpoint</Form.Label>
                        <Form.Control readOnly={mode} style={{backgroundColor: mode ? '#f3f3f3' : ''}} type="url" name="userEndpoint" value={model.userEndpoint} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="jwksEndpoint">
                        <Form.Label>JWKS endpoint</Form.Label>
                        <Form.Control readOnly={mode} style={{backgroundColor: mode ? '#f3f3f3' : ''}} type="url" name="jwksEndpoint" value={model.jwksEndpoint} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                  </Col>
                </Row>
              </Form>

              <Button  onClick={this.handleSave}>
                {loading ? 'Loading...' : 'Save changes'}
              </Button>
            </div>
          ) }
          { !loading && sso.saved && (
            <div className='white_box_details'>
              <h3><span className={`check_mark ${sso.authorization ? 'green' : 'gray'}`}></span>Application registration</h3>
              <Form className='form_billing'>
                <Row>
                  <Col sm={12}>
                    <Col sm={12}>
                      <Form.Group controlId="redirectUrl">
                        <Form.Label>Redirect URI</Form.Label>
                        <Form.Control readOnly style={{backgroundColor: '#f3f3f3'}} type="url" name="redirectUrl" value={model.redirectUrl} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="scopes">
                        <Form.Label>Scopes</Form.Label>
                        <Form.Control readOnly style={{backgroundColor: '#f3f3f3'}} type="url" name="scopes" value={model.scopes} onChange={this.handleChange} />
                        <small className="text-muted">Additional scopes must be separated by a comma</small>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="responseTypes">
                        <Form.Label>Response type</Form.Label>
                        <Form.Control readOnly style={{backgroundColor: '#f3f3f3'}} type="url" name="responseTypes" value={model.responseTypes} onChange={this.handleChange} />
                        <small className="text-muted">Response type: code, token, id tokent</small>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="clientId">
                        <Form.Label>Client ID</Form.Label>
                        <Form.Control placeholder={model.authorization ? '*************************' : ''} type="password" name="clientId" value={model.clientId} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group controlId="clientSecret">
                        <Form.Label>Client Secret</Form.Label>
                        <Form.Control placeholder={model.authorization ? '*************************' : ''} type="password" name="clientSecret" value={model.clientSecret} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                  </Col>
                </Row>
              </Form>

              <Button onClick={this.handleSaveSecret}>
                {loading ? 'Loading...' : 'Save changes'}
              </Button>
            </div>
          )}
          { !loading && sso.saved && sso.authorization && (
            <div className='white_box_details'>
              <h3><span className={`check_mark ${sso.verified ? 'green' : 'gray'}`}></span>Verify registration and Sing in</h3>
              <Button disabled={sso.verified} onClick={this.handleVerify}>
                {loading ? 'Loading...' : 'Verify'}
              </Button>
            </div>
          )}
          { !loading && sso.saved && sso.authorization && sso.verified && (
            <div className='white_box_details'>
              <h3><span className={`check_mark ${sso.activated ? 'green' : 'gray'}`}></span>Activate Single Sign-in</h3>
              {sso.activated && (
                <Form className='form_billing'>
                  <Row>
                    <Col sm={12}>
                      <Form.Group controlId="loginUrl">
                        <Form.Label>Login URL</Form.Label>
                        <Form.Control readOnly style={{backgroundColor: '#f3f3f3'}} type="url" name="loginUrl" value={`${window.location.origin}/sso/login/${user.selectedAccount}`} onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              )}
              <Button disabled={sso.activated} onClick={this.handleActivate}>
                {loading ? 'Loading...' : 'Activate'}
              </Button>
            </div>
          )}
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(error(err)),
    fetchSso: (url) => dispatch(fetchSso(url)),
    getSso: () => dispatch(getSso()),
    setSso: (data) => dispatch(setSso(data))
  }
};

const mapStateToProps = state => {
  return {
    sso: state.sso.sso,
    user: state.auth.user,
    loading: state.sso.loading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SsoConfig));
